import React, { useEffect, useRef, useState } from 'react'

//CSS
import './Webinars.css'

//MUI
import { Box, Button, Container, Grid, Typography, useMediaQuery } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MicIcon from '@mui/icons-material/Mic';

//img
import portada from '../../../Assets/Images/PortadaWebinars.jpeg'
import img from '../../../Assets/Images/proxwebinar.png'

//Router dom
import { Link } from 'react-router-dom'

const Webinars = () => {
    const [data, setData] = useState([])
    const [oldData, setOldData] = useState([])
    const [visible, setVisible] = useState(3)
    const [oldVisible, setOldVisible] = useState(4)
    const [expanded, setExpanded] = useState(false)
    const matches = useMediaQuery('(max-width: 650px)')
    const matches_text = useMediaQuery('(max-width: 575px)')
    const ref = useRef(null)
    const oldRef = useRef(null)

    const handleShowMore = () => {
        setVisible((i) => i + 3)
        setExpanded(true)
    };

    const handleShowLess = () => {
        setVisible(3)
        setExpanded(false)
        ref.current.scrollIntoView({ behavior: 'smooth' });
    }

    const handleOldShowMore = () => {
        setOldVisible((i) => i + 4)
    };

    const handleOldShowLess = () => {
        setOldVisible(4)
        oldRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    useEffect(() => {
        const savedForms = JSON.parse(localStorage.getItem('webi')) || [];
        setData(savedForms)

        const savedOldForms = JSON.parse(localStorage.getItem('oldWebinars')) || [];
        setOldData(savedOldForms)
    }, []);

    const formatFecha = (dateString) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];

        const date = new Date(dateString);
        const day = date.getDate();
        const month = meses[date.getMonth()];
        const year = date.getFullYear();

        return `${day} de ${month} del ${year}`;
    };

    return (
        <>
            <Box
                component='img'
                src={portada}
                alt="Webinars"
                sx={{
                    width: '100%',
                    height: matches ? '100%' : 550,
                    objectFit: 'cover',
                }}
            />

            <div ref={ref} />

            <div style={{ backgroundColor: '#FAFAFA', padding: '50px 0', margin: '40px 0' }}>
                <Container maxWidth='lg'>
                    <Typography variant='h4' textAlign='center' sx={{ color: '#000c77', fontWeight: '500' }} paragraph>Próximos webinars</Typography>
                    {
                        data.filter(res => res.isFinished !== true).slice(0, visible).map((res, index) => {
                            const now = new Date()
                            const eventDateTime = new Date(`${res.date}T${res.time}`)

                            return (
                                <Box key={index} sx={{ p: 3, boxShadow: 3, mb: 5, borderRadius: '4px' }}>
                                    {/* IMPORTANTE!!!! Reemplazar imagen por la original */}
                                    <Grid container spacing={4} alignItems='center'>
                                        <Grid item xxl={4.5} xl={4.5} lg={4.5} md={4.5} sm={5.5} xs={12}>
                                            <Box
                                                component='img'
                                                src={img}
                                                alt='NWebinar'
                                                sx={{
                                                    width: '100%',
                                                    objectFit: 'cover',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xxl={7.5} xl={7.5} lg={7.5} md={7.5} sm={6.5} xs={12} sx={{ textAlign: matches_text ? 'center' : 'left' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1, mb: 2 }}>
                                                {now >= eventDateTime && res.isFinished !== true && <MicIcon color='error' className='online_icon' />}
                                                <Typography variant='h5' sx={{ color: '#000c77', fontWeight: '500' }}>
                                                    {
                                                        (() => {
                                                            if (eventDateTime > now) return 'Próximamente';
                                                            if (now >= eventDateTime && res.isFinished !== true) return 'En vivo';
                                                            return 'Este evento ha terminado';
                                                        })()
                                                    }
                                                </Typography>
                                            </Box>
                                            <Typography variant='body1' paragraph>{res.title}</Typography>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item>
                                                    <CalendarMonthIcon sx={{ color: '#000c77' }} />
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body1">
                                                        <span style={{ fontWeight: '500', color: '#000c77' }}>Fecha:</span> {formatFecha(res.date)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item>
                                                    <AccessTimeIcon sx={{ color: '#000c77' }} />
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="body1" sx={{ fontWeight: '500' }}>
                                                        <span style={{ color: '#000c77' }}>Hora:</span> {res.time} hrs (CDMX)
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Box sx={{ mt: 3 }}>
                                                <Button variant='contained' component={Link} to={`/webinars/${res.title}`}>
                                                    {
                                                        eventDateTime > now
                                                            ?
                                                            '¡Inscribete Gratis!'
                                                            :
                                                            now >= eventDateTime && res.isFinished !== true ?
                                                                'Ver ahora'
                                                                :
                                                                'Ver detalles'
                                                    }
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )
                        })
                    }
                    {
                        !expanded && data.filter(res => res.isFinished !== true).length > 3 &&
                        <Box textAlign="center">
                            <Button variant="outlined" onClick={handleShowMore}>
                                Ver más
                            </Button>
                        </Box>
                    }
                    {
                        expanded && data.filter(res => res.isFinished !== true).length > 3 &&
                        <Box textAlign="center">
                            <Button variant="outlined" onClick={handleShowLess}>
                                Ver menos
                            </Button>
                        </Box>
                    }
                </Container>
            </div>

            <div ref={oldRef} />

            <Container maxWidth='xl' sx={{ mb: 6 }}>
                <Box textAlign='center' mb={5}>
                    <Typography variant='h4' sx={{ color: '#000c77', fontWeight: '500' }} paragraph>WEBINARS ANTERIORES</Typography>
                    <Typography variant='body1' color='text.secondary'>
                        <span style={{ fontWeight: '600' }}>¿Te perdiste alguno de nuestros webinars?</span> No te preocupes, aquí te dejamos los enlaces para acceder a ellos.
                    </Typography>
                </Box>
                <Grid container spacing={4} sx={{ mb: 3 }}>
                    {
                        oldData.slice(0, oldVisible).map((item, index) => (
                            <Grid item xxl={6} xl={6} lg={6} md={10} sm={12} xs={12} key={index}>
                                <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px' }}>
                                    <iframe
                                        src={item.iframe}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="OldWebinar"
                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                    >
                                    </iframe>
                                </Box>
                            </Grid>
                        ))
                    }
                </Grid>
                {
                    oldVisible < oldData.length && oldData.length > 1 &&
                    <Box textAlign="center">
                        <Button variant="outlined" onClick={handleOldShowMore}>
                            Ver más
                        </Button>
                    </Box>
                }
                {
                    oldVisible > oldData.length && oldData.length > 1 &&
                    <Box textAlign="center">
                        <Button variant="outlined" onClick={handleOldShowLess}>
                            Ver menos
                        </Button>
                    </Box>
                }
            </Container>
        </>
    )
}

export default Webinars